interface ShareData {
  title: string;
  text: string;
  url: string;
}

export const SHARE_CONTENT: ShareData = {
  title: 'Canadian Grant Hub',
  text: "I've been using this tool to find grants in Canada and thought it might help you.",
  url: 'https://grant-hub.vercel.app',
};

export const generateEmailLink = (): string => {
  const subject = encodeURIComponent('Helpful tool for finding Canadian grants');
  const body = encodeURIComponent(
    `Hi,\n\nI found this grant search platform that connects you to specialized tools for different funding needs:\n\n${SHARE_CONTENT.url}\n\nIt has tools for:\n- Disability support grants\n- Small business funding\n- And more categories\n\nBest regards`
  );
  return `mailto:?subject=${subject}&body=${body}`;
};

export const handleNativeShare = async (): Promise<boolean> => {
  if (navigator.share) {
    try {
      await navigator.share(SHARE_CONTENT);
      return true;
    } catch (error) {
      console.error('Share failed:', error);
      return false;
    }
  }
  return false;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Copy failed:', err);
    return false;
  }
};

export const generateTwitterLink = (): string => {
  const text = encodeURIComponent(
    'Found a great resource for finding Canadian grants! Check it out:'
  );
  return `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(SHARE_CONTENT.url)}`;
};

export const generateLinkedInLink = (): string => {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(SHARE_CONTENT.url)}`;
};
